mobileSize = 1100;
function strates() {
  if ($('body').hasClass('saffireMobileSize')) {
      $('.strates-logo').prependTo('.header-left');
  } else {
      $('.strates-logo').appendTo('.countdown-outer');
  }
}

function cartLink() {
  if ($('body').hasClass('saffireMobileSize')) {
      $(".mobile-menu-cart").appendTo(".header-bottom .container");
  } else {
      $(".mobile-menu-cart").remove();
  }
}

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1101) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1101) {
    $('body').removeClass('saffireMobileSize');
  }
   //Signup Input text Reappeare
	 var emailInput = $('.subscribemain .emailInputField input');
	 emailInput.val('Enter Email Address');
	 emailInput.on("click", function () {
		 ClearDefaultText(this, 'Enter Email Address');
	 });
	 emailInput.on("blur", function () {
		 if ($.trim($(this).val()) == '') {
			 $(this).val('Enter Email Address');
		 }
	 });
  strates();
  cartLink();
  // General Message
  $('.generalmessage').prependTo('header');
  $('.subscribemain .emailSignupText').text('GET UPDATES!');
  $(".subscribemain .emailSubmitButton").html("SUBSCRIBE");
  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});

$(window).load(function(){
  $('body').addClass('pageIsLoaded');
  strates();
  cartLink();
  setInterval(function() {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if(!weatherBugSet && str != ''){
      $('#weatherBugWidget').addClass('weatherBugSet');
        var findSpace = str.lastIndexOf(' ');
        var stringLength = str.length;
        var res = str.substring(findSpace, stringLength);
        var start = str.substring(0, findSpace);
        $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
        $('#weatherBugWidget').css('visibility', 'visible');
    }
  },12);
});
$(window).resize(function () {
  strates();
  cartLink()
});